import React from "react";
import ReactDOM from "react-dom";
import "firebase/messaging";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./i18n";

import { Loader } from "components/Loader";
import { store, persistor,  } from "./store";

import App from "./App";

const app = (
    <Provider store={store}>
        <PersistGate loading={<Loader size="sm" />} persistor={persistor}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((reg) => {
            console.log("service worker registered");
        })
        .catch((err) => {
            console.log(err);
        });
}

